import api from "./api";

class VideoService {
    list(params = {}) {
        return api.get("/api/videos/", { params });
    }
    get(id) {
        return api.get(`/api/videos/${id}/`);
    }
    listCategories() {
        return api.get("/api/videos/categories/");
    }
}

export default new VideoService();
